import { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import db, { collection, query, where, onSnapshot } from '../firebase/firestore';

export function useUnreadMessages() {
  const { academyId, isAcademyAdmin } = useAuth();
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!academyId || !isAcademyAdmin) return;
    const q = query(collection(db, 'messages'), where('academyId', '==', academyId));
    return onSnapshot(q, (snap) => {
      const msgs = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
      const byThread = {};
      msgs.forEach((m) => {
        const gid = m.guardianUserId;
        if (!gid) return;
        if (!byThread[gid]) byThread[gid] = { latestGuardian: null, latestAdmin: null };
        const ts = m.createdAt?.seconds || 0;
        if (m.fromRole === 'guardian') {
          if (!byThread[gid].latestGuardian || ts > (byThread[gid].latestGuardian.createdAt?.seconds || 0))
            byThread[gid].latestGuardian = m;
        } else if (m.fromRole === 'academyAdmin') {
          if (!byThread[gid].latestAdmin || ts > (byThread[gid].latestAdmin.createdAt?.seconds || 0))
            byThread[gid].latestAdmin = m;
        }
      });
      const unread = Object.values(byThread).filter((t) => {
        if (!t.latestGuardian) return false;
        if (!t.latestAdmin) return true;
        return (t.latestGuardian.createdAt?.seconds || 0) > (t.latestAdmin.createdAt?.seconds || 0);
      }).length;
      setCount(unread);
    }, () => setCount(0));
  }, [academyId, isAcademyAdmin]);

  return count;
}
